import { HttpClient } from "../CBP_App/api/httpClient";




export const getJourneyDetails = ({ shipmentId, mbol }) => {
  const data = {
    eventMessage: { mbol, shipmentId },
    eventType: 'EED_SHIPMENT_JOURNEY',
    eventTime: Date.now(),
  };
  return HttpClient.custom({ data });
};
